function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React, { Component } from 'react';
import { iconNames } from "../../UI/Icon/library";
import { CountryList } from "../../UI";
import DropdownList from 'react-widgets/lib/DropdownList';
import IconSelectorItem from "./IconSelectorItem";

export default class IconSelector extends Component {
  constructor(props) {
    super(props);
    const listOptions = [{ _id: null, type: 'Empty' }].
    concat(
    iconNames.map((icon) => ({
      _id: icon,
      type: 'Icons',
      label: icon
    }))).

    concat(
    Array.from(CountryList).map((country) => ({
      _id: country[1].cca3,
      type: 'Flags',
      label: country[1].label
    })));


    this.state = { listOptions };
  }

  render() {
    return /*#__PURE__*/(
      React.createElement(DropdownList, _extends({
        valueField: "_id",
        textField: "label",
        data: this.state.listOptions,
        valueComponent: IconSelectorItem,
        itemComponent: IconSelectorItem,
        defaultValue: this.state.listOptions[0],
        filter: "contains",
        groupBy: "type" },
      this.props)));


  }
}